import { http } from "@canvas/api";

export interface InventorySearchReq {
  endpoint: "ragnarok.swatch.v1.inventory.search";
  query: string;
}

export interface InventorySearchQuery {
  // limit: number | null ,
  // name__contains: string | null,
  // offset: number | null,
  // order_by: number | null
}

export interface InventorySearchRes {
  error: string;
  response: {
    count: number;
    results: any[];
  };
}

export function get(req: InventorySearchReq): Promise<InventorySearchRes> {
  return http
    .GET(`/ragnarok/swatch/v1/inventory?${req.query}`)
    .then((response: InventorySearchRes) => {
      // validate response here
      return response;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
